export enum SuggestedQuality {
  'default',
  'small',
  'medium',
  'large',
  'hd720',
  'hd1080',
  'highres'
}


class Player
{
    videoId                  : string;
    width                    : string;
    height                   : string;
    endSeconds               : number;
    startSeconds             : number;
    suggestedQuality         : SuggestedQuality;
    showBeforeIframeApiLoads : boolean;

    constructor(player?)
    {
        player                        = player || {};
        this.width                    = player.width || 780;
        this.height                   = player.height || 420;
        this.videoId                  = player.videoId || '';
        this.startSeconds             = player.startSeconds || 0;
        this.endSeconds               = player.endSeconds || null;
        this.suggestedQuality         = player.suggestedQuality || SuggestedQuality.default;
        this.showBeforeIframeApiLoads = player.showBeforeIframeApiLoads || true;
    }
}

export default Player;
